import {HttpClientService} from "../../../core/services/http-client.service";
import {CommonService} from "../../../core/services/common.service";
import {ToastService} from "../../../core/services/toast.service";
import {Router} from "@angular/router";
import {Component, HostListener} from "@angular/core";
import {Observable} from "rxjs";

@Component({
  selector: 'app-details',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent {
  cancel: any
  offset: number = 0;
  canLoadMore: boolean = true;
  selectedOrder: any;
  reason:string='';
  loading = false;
  constructor(private http: HttpClientService, private common: CommonService, private toast: ToastService ,private router: Router) {
    this.customer = this.common.getStorage('customer');
  }
  customer: any;
  orders: any[]=[];
  visible: boolean=false;
  ngOnInit(): void {
    this.orders=[];
    this.getOrderList();
  }
  callGetOrderList(obj) {
    if (!this.canLoadMore) {
      return;
    }
    this.getCustomerOrderList(obj)
      .subscribe(data => {
        if (data['responseStatus'].toLowerCase() == 'success') {
          if (data["response"].length > 0) {
            for (let o of data['response']) {
              this.orders.push(o);
            }
            this.offset = obj.offset + obj.limit;
          } else {
            this.canLoadMore = false;
          }
        }
      }, error => {});
  }
  navigateToOrder(orderId: string) {
    this.router.navigate([`user/profile/orders/${orderId}`]);
  }
  public openModal(order) {
    this.selectedOrder = order;
    this.visible = true;

  }
  getCustomerOrderList(obj): Observable<any>{
    return this.http.get("store/order", obj);
  };

  cancelRequest() {
    if(this.reason ==undefined){
      this.toast.error("Please Mention the Reason");
      return false;
    }
    this.http.post('cancelPendingOrderItem?id=' + this.selectedOrder.pendingOrderItemId + "&statusDescription=cancel by" + this.customer.id +"&reason="+this.reason).subscribe(
      data => {
        if (data.responseStatus == 'SUCCESS') {
          if (this.selectedOrder.payMethod == 'POD' || this.selectedOrder.payMethod == 'EMIOD') {
            this.toast.success("Order Cancel Successfully");
          } else {
            this.toast.success("Your amount will be refunded soon");
          }
          this.offset = 0;
          this.orders = [];
          this.getOrderList();
        } else {
          this.toast.error("Something went wrong. Please try after some time.");
          this.loading = false;
        }
      },
      err => {
        if (err.statusCode == 400) {
          this.toast.error(err.json().response.message)
        } else {
          this.toast.error("Something went wrong")
        }
        this.loading = false;
      }
    );
    this.visible=false;
  }

  getOrderList() {
    this.customer = this.common.getStorage('customer');
    let obj = {
      id: this.customer.id,
      offset: this.offset,
      limit: 20
    }
    this.callGetOrderList(obj);
  }

  downloadInvoice(order){
    this.http.downloadFile("store/generateInvoice?orderId="+order.itemId,'application/pdf')
      .subscribe((blob:any) => {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download =  order.id+`invoice.pdf`;
        link.click();
      }, error => {
        if (error.statusCode == 400) {
          this.toast.error(error.response.message)
        }
        else {
          this.toast.error("Something went wrong")
        }
      });
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    if (!this.canLoadMore) {
      return; // Exit if no more items can be loaded
    }
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollHeight - scrollTop <= clientHeight + 100) {
      this.getOrderList();
    }
  }

  redirectToShop() {
    this.router.navigate([`/`]);
  }
}
